import { useToastNotification } from 'utils/hooks/useToastNotification';

import { UNKNOWN_ERROR_MESSAGE } from '../constants';

export const useErrorToast = (enabled: boolean) =>
  useToastNotification({
    enabled,
    negative: true,
    negativeMessage: UNKNOWN_ERROR_MESSAGE,
  });
